import { getUrlParameter } from 'mdt-core-components/src/helpers/commonUtils.js';
import { MDTApp } from 'mdt-core-components/src/actions/bootAction.js';
import _ from 'lodash';

const appId = window.routeSettings.appRoute;

const handlePageLeave = (state) => {
    // NOTE: Redefine window.confirm method to use custom modal
    // component instead of browser's default 20221219:Alevale
    window.confirm = () => true;

    // NOTE: In some places we have to bypass the block navigation
    // in case there's redirects or other kind of logic
    // that go hand in hand with normal user actions 20221222:Alevale
    if (state.blockNavigation?.bypassBlockNavigation) {
        return false;
    }
    return 'leavingPageConfirmation';
};

const routesMap = {
    HOME: {
        path: `/apps/${window.routeSettings.portalRoute}/`,
        thunk: async (dispatch, getState) => {
            const isLogin = getState().meDetails.meState.LOGGED_IN;
            // TODO: This is here to handle the redirect from MyOrders 20250203:Alevale
            let refreshToken = getUrlParameter('redirect-token') || null;
            // TODO: Make this depend on the new authentication tokens 20250203:Alevale
            if (refreshToken && !_.isNull(refreshToken) && refreshToken !== 'undefined') {
                refreshToken = decodeURIComponent(refreshToken);
                sessionStorage.setItem('apiRefreshToken', refreshToken);
                MDTApp.initBootstrap();
                dispatch({ type: 'PORTAL' });
            } else {
                !isLogin ? dispatch({ type: 'LOGIN' }) : dispatch({ type: 'PORTAL' });
            }
        },
    },

    PORTAL: {
        path: `/apps/${window.routeSettings.portalRoute}/`,
        thunk: async () => {},
    },
    ACCOUNTSETUP: `/apps/${window.routeSettings.portalRoute}/accountSetup`,
    // PORTAL: '/',
    LOGIN: `/apps/${window.routeSettings.portalRoute}/login`,
    LOGOUT: {
        path: `/apps/${window.routeSettings.portalRoute}/logout`,
        thunk: async () => {
            // NOTE: We need just the logout page placeholder so that we can handle the redirect to the IdP after the fact.
            // This is not really holding any logic, but it's just to handle redirects through the AuthGuard 20250425:Alevale
        },
        externallyAccessible: true,
    },
    NOTIFICATIONDETAILS: `/apps/${window.routeSettings.portalRoute}/notificationDetails`,
    FORGOTPASSWORD: `/apps/${window.routeSettings.portalRoute}/forgotpassword`,
    REQUESTADDITIONALACCESS: `/apps/${window.routeSettings.portalRoute}/requestAdditionalAccess`,
    USERPREFERENCES: `/apps/${window.routeSettings.portalRoute}/userPreferences`,
    REQUESTACCESS: {
        path: `/apps/${window.routeSettings.portalRoute}/requestAccess`,
        externallyAccessible: true,
        shouldPromptLeaveConfirmation: true,
        role: 'notlogin', // + set the user's role to admin
    },
    ADMIN: {
        path: `/apps/${window.routeSettings.portalRoute}/admin`,
        thunk: async () => {},
    },
    MANAGEACTIVECUSTOMERS: `/apps/${window.routeSettings.portalRoute}/manageActiveCustomers`,
    MANAGEMYACCOUNTS: `/apps/${window.routeSettings.portalRoute}/manageMyAccounts`,
    CONTACTUS: {
        path: `/apps/${window.routeSettings.portalRoute}/contactUs`,
        externallyAccessible: true,
    },
    TERMSANDCONDITIONS: `/apps/${window.routeSettings.portalRoute}/termsAndConditions`,
    PRODUCTDETAILS: {
        path: `/apps/${appId}/productdetails`,
        externallyAccessible: true,
    },
    SEARCHPRODUCT: {
        path: `/apps/${appId}/searchProduct`,
        externallyAccessible: true,
    },
    VIEWCATALOG: {
        path: `/apps/${appId}/viewCatalog`,
        externallyAccessible: true,
    },
    MECAPP: {
        path: `/apps/${appId}/mecApp`,
        externallyAccessible: true,
    },
    DOWNLOADCATALOG: {
        path: `/apps/${appId}/downloadCatalog`,
        externallyAccessible: true,
    },
    FILEUPLOAD: `/apps/${appId}/fileUpload`,
};
Object.keys(routesMap).forEach((key) => {
    const route = routesMap[key];
    if (route.shouldPromptLeaveConfirmation) {
        route.confirmLeave = handlePageLeave;
    }
});

window.routeSettings.routesMap = routesMap;

export default routesMap;
